import React, { useEffect, useState } from 'react';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import ReceiptHelper from '../helpers/receipt.helper';
import apiPDFDownload from '../../../../utils/api-pdf-download';
import { useReceiptContext } from '../context/receipt.context';
import { useTrackingContext } from '@jbhi-fi/components/src/Tracking';
import { UnverifiedDownloadIcon } from './UnverifiedDownloadIcon';
import { PerksDownloadIcon } from './PerksDownloadIcon';

const receiptHelper = new ReceiptHelper();

const DownloadComponent = ({ receiptId, receiptToken, history, setError, preventAutoDownload = true, isClaimed }) => {
  const { data, setReceiptData, trackingData } = useReceiptContext();
  const { tracker } = useTrackingContext();
  const [isPreparing, setIsPreparing] = useState(false);

  useEffect(() => {
    if (!preventAutoDownload) {
      downloadReceipt();
    }
  }, []);

  const downloadReceipt = async () => {
    setIsPreparing(true);
    if (preventAutoDownload) {
      tracker.group = data.receipt?.ItemLinked ? 'claimed' : 'unclaimed';
      tracker.trackClick({
        label: 'download',
        extraData: { purchases: [{ type: 'in-store receipts', receiptId: receiptId, ...trackingData }] },
      });
    }

    const downloadResponse = await receiptHelper.downloadReceipt(receiptId, receiptToken);
    if (downloadResponse.ErrorCode) {
      if (downloadResponse.ErrorCode === 'UnauthorisedForReceipt') {
        receiptHelper
          .sendReceiptVerification(receiptId)
          .then(result => {
            setReceiptData({ ...data.receipt, MessageReference: result.MessageReference });
            history.push(`/${receiptId}/verify-once?download=true`);
          })
          .catch(() => {
            setError(true);
            setIsPreparing(false);
          });
      } else {
        setError(true);
        setIsPreparing(false);
      }
      return;
    } else {
      setError(false);
      apiPDFDownload(downloadResponse, `JBHiFi-Receipt-${receiptId}`);
    }

    setTimeout(() => {
      setIsPreparing(false);
    }, 1000);
  };
  return window.Jbhifi.isPerksDisabled ? (
    <div className="unverifiedDownload">
      <JBButton
        label="Download"
        onClick={isPreparing ? null : downloadReceipt}
        type="secondary"
        icon={<UnverifiedDownloadIcon />}
        iconPosition="left"
        classes="downloadLogo"
        size="sm"
        loading={isPreparing}
      />
    </div>
  ) : (
    <div className={`download ${isClaimed ? 'downloadClaimed' : ''}`}>
      <JBButton
        label="Download receipt"
        onClick={isPreparing ? null : downloadReceipt}
        type="secondary"
        icon={<PerksDownloadIcon />}
        iconPosition="left"
        padding="0px"
        fullWidth
        loading={isPreparing}
      />
    </div>
  );
};

export default DownloadComponent;
